import TutorialStep4_2 from './TutorialStep4_2';

export default TutorialStep4_2;
